import cx from 'classnames';
import { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import ArrowRightUpIcon2 from '../../SVGIcons/ArrowRightUpIcon2';
import { Tag } from '../../UI/Tag';
import classes from './VacanciesCard.module.scss';
import { VacanciesCardProps } from './VacanciesCard.types';

export const VacanciesCard: FC<VacanciesCardProps> = ({
  className,
  title,
  tag,
  tagsList,
  idForUrl,
}): ReactElement => (
  <Link
    to={`/vacancies/id/${idForUrl}`}
    className={cx(classes['vacancies-card-link'], className)}
  >
    <div className={classes['vacancies-card']}>
      <div className={classes['vacancies-card__content']}>
        <h3 className={classes['vacancies-card__title']}>{title}</h3>
        <ArrowRightUpIcon2 className={classes['vacancies-card__icon']} />
      </div>
      <div className={classes['vacancies-card__tags']}>
        <Tag
          className={cx(
            classes['vacancies-card__tag'],
            classes['vacancies-card__tag-direction'],
          )}
          variantColor="white"
          fontWeight="medium"
        >
          {tag.value}
        </Tag>
        {tagsList.map((item) => (
          <Tag key={item} className={classes['vacancies-card__tag']}>
            {item}
          </Tag>
        ))}
      </div>
    </div>
  </Link>
);
